import api from './api';

const SystemService = {
  GetAllSystems: () => {
    return api
      .get('/System/GetAllSystems')
      .then(response => response)
      .catch(error => {
        console.error('Service Error - GetAllSystems:', error);
        throw error;
      });
  },

  GetSystemByName: (systemName) => {
    if (!systemName) {
      return Promise.reject(new Error("System name is required"));
    }

    return api
      .get(`/System/GetSystemById?system_name=${encodeURIComponent(systemName)}`)
      .then(response => response)
      .catch(error => {
        console.error('Service Error - GetSystemByName:', error);
        throw error;
      });
  },

  AddSystem: (data) => {
    if (!data?.system_name) {
      return Promise.reject(new Error("System name is required"));
    }

    // ✅ Correct: only system_name and description as query params, POST body null
    return api
      .post('/System/AddSystem', null, {
        params: {
          system_name: data.system_name,
          description: data.description || ""
        }
      })
      .then(response => response)
      .catch(error => {
        console.error('Service Error - AddSystem:', error.response?.data || error.message);
        throw error;
      });
  }
};

export default SystemService;
